// Copyright (c) 2020 Deere & Company

import * as fetchService from '../../../shared/services/fetch';
import { getBasePath } from '../../../shared/services/get-base-path';
import { handleError } from '../../../shared/services/error-handlers';

const basePath = getBasePath();

export async function getCheckOrdersOrderDetail ( family, dateValue ) {

    const endPoint = `${basePath}/check-orderdetails`;
    const payLoad = {
        familytype: family,
        dateType: dateValue
    };

    const options = {
        body: JSON.stringify( payLoad ),
        headers: {'Content-Type': 'application/json'},
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function getCheckOrdersOrderCodeDetail ( family, dateValue,
    orderingCode, orderBuildWeek ) {

    const endPoint = `${basePath}/checkdetails`;
    const payLoad = {
        familytype: family,
        dateType: dateValue,
        orderingCode,
        orderBuildWeek

    };

    const options = {
        body: JSON.stringify( payLoad ),
        headers: {'Content-Type': 'application/json'},
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}
